export default __webpack_public_path__ + "static/media/0xaf24765f631c8830b5528b57002241ee7eef1c14.91e9136f.webp";